import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { auth, AuthState } from "@/store/modules/auth.ts";
import {
  CompleteEnrolementRequest,
  CompleteEnrolementRequestInit,
} from "@/model/request/auth/CompleteEnrolementRequest.ts";
import { Textfield } from "@/components/ui/input/textfield";
import { Button, Modal } from "@/components/ui";
import { codeSchema } from "@/utilities/validation/authSchema";
import { useNavigate } from "react-router-dom";
import { RouteConstant } from "@/util/constant/RouteConstant";

export function OtpForm() {
  const [modalVisible, setModalVisible] = useState(false);
  const [response, setResponse] = useState("");
  const [accountModal, setAccountModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);

  const authState = useSelector<any>((state) => state.auth) as AuthState;
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const goToLogin = () => navigate(RouteConstant.auth.login.path);
  const goToCreated = () => setAccountModal(true);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const secondsFormatted = seconds > 9 ? seconds : `0${seconds}`;

  const handleSubmit = async (value: CompleteEnrolementRequest) => {
    const request = {
      ...value,
      otp: value.otp,
      userEmail: authState.userEmail,
    };

    await dispatch(
      auth.action.completeEnrollment({
        data: request,
        onSuccess: goToCreated,
        onError: (res: any) => {
          setResponse(res.responseMessage);
          
          setModalVisible(true);
        },
      })
    );
  };

  const resendOtp = () => {
    dispatch(
      auth.action.resendOtp({
        data: { userEmail: authState.userEmail },
      })
    );
    setTimeLeft(60); // reset timer on resend
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues: CompleteEnrolementRequestInit,
    validationSchema: codeSchema,
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Textfield
          name="otp"
          label="OTP"
          placeholder="Enter OTP"
          type="text"
          inputMode="numeric"
          formik={formik}
          error={formik.touched.otp && formik.errors.otp}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/\D/g, "");
          }}
        />

        <div className="w-layout-grid form-button-wrapper">
          <Button
            type="submit"
            state="primary"
            className="w-full mt-5"
            label="Verify OTP"
            isLoading={authState.loading}
            disabled={!formik.isValid || authState.loading}
          />
        </div>

        {timeLeft <= 30 && (
          <div className="text-center mt-3">
            <p>
              Didn't get a code?
              <button
                onClick={resendOtp}
                type="button"
                className="text-secondary ml-2"
              >
                Resend OTP ({minutes}:{secondsFormatted})
              </button>
            </p>
          </div>
        )}
      </form>

      <Modal
        title={`Welcome, ${authState?.userEmail}!🎉`}
        text="Account has been created successfully."
        type="success"
        modal={accountModal}
        buttonLabel="Proceed to Login"
        onClose={goToLogin}
        onClick={goToLogin}
      />

      <Modal
        title="Signup Failed"
        text={response}
        type="error"
        modal={modalVisible}
        onClose={() => setModalVisible(false)}
        buttonLabel="Close"
        onClick={() => setModalVisible(false)}
      />
    </>
  );
}
